import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				maxHeight: 450,
				overflow: "scroll"
			},
			title: {
				fontSize: 20,
				fontWeight: 600,
				color: theme.palette.secondary.contrastText,
				textAlign: "center",
				marginBottom: 10
			},
			subTitle: {
				fontWeight: 500,
				color: theme.palette.primary.contrastText,
				fontSize: 15
			},
			condition: {
				background: theme.palette.info.contrastText,
				borderRadius: 8,
				padding: 10,
				marginTop: 10,
				fontSize: 15
			},
			textTime: {
				color: theme.palette.secondary.main,
				fontSize: 15
			},
			mb30: {
				marginBottom: 30
			},
			rootProgram: {
				display: "flex",
				alignItems: "center",
				marginTop: 10
			},
			iconProgram: {
				"& > img": {
					marginRight: 5,
					width: 28,
					height: 28
				}
			},
			titleProgram: {
				color: theme.palette.secondary.contrastText,
				fontSize: 16,
				"& >span": {
					fontWeight: 500
				}
			}
		}),
	{
		name: "DialogLoyalty",
		index: 1
	}
);

export default useStyles;
